import { TemplateIds, TemplateIdsSchema } from "../../models/uv-inserts/template-ids";
import { TemplateIdsDTO } from "./types"

export const transformRawToTemplateIds = ({
  dto
}: { dto?: TemplateIdsDTO }): TemplateIds => {
  if(!dto) return {};

  return TemplateIdsSchema.parse(dto)
}